// src/components/sacred/SectionLabel.jsx
// Small uppercase Work-Sans label used above data/chart sections.

import React from 'react';
import { Typography } from '@mui/material';

const SectionLabel = ({ children, sx = {}, ...rest }) => (
  <Typography
    variant="caption"
    sx={(t) => ({
      fontFamily: 'var(--sacred-font-label)',
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
      fontSize: '0.72rem',
      fontWeight: 500,
      color: t.palette.sacred.outline,
      display: 'block',
      mb: 0.5,
      ...sx,
    })}
    {...rest}
  >
    {children}
  </Typography>
);

export default SectionLabel;
